import { SPLoading } from '@group-link-one/gl-ui/sonarprint';
import type { JSX } from 'react';
import { Suspense } from 'react';
import { Navigate, useSearchParams } from 'react-router-dom';

interface RequireQueryParamProps {
  param: string;
  Component: React.LazyExoticComponent<React.ComponentType>;
}

/**
 * Wrapper para rotas que requerem query parameter
 */
export const RequireQueryParam = ({ param, Component }: RequireQueryParamProps): JSX.Element => {
  const [searchParams] = useSearchParams();

  if (!searchParams.get(param)) {
    return <Navigate to='/' replace />;
  }

  return (
    <Suspense fallback={<SPLoading screen='as-full-screen' type='dots' />}>
      <Component />
    </Suspense>
  );
};
